module.exports = __webpack_public_path__ + "static/img/3.05ab51c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/3.png
// module id = /6Rp
// module chunks = 0